// extracted by css-extract-rspack-plugin
export default {"container":"container-qgFKS0","value":"value-HODLkL","label":"label-UY5Y2Z"};